// import router from '@/router'
const state = {}

const getters = {}

const mutations = {}

const actions = {}

export default {
    state,
    getters,
    mutations,
    actions
}



// WEBPACK FOOTER //
// ./src/store/modules/product.js